import { addEventListener, isElement, isWindow, selectOne, } from 'vevet-dom';
import { Component } from '../../base/Component';
/**
 * Drag & Swipe events. An abstract class
 */
export class Dragger extends Component {
    constructor(initialProp, init = true) {
        super(initialProp, false);
        // get container
        this._container = selectOne(this.prop.container);
        if (!isElement(this._container) && !isWindow(this._container)) {
            throw new Error('No container');
        }
        // set default vars
        this._runtimeEvents = [];
        this._isDragging = false;
        this._pointerID = null;
        this._coords = { x: 0, y: 0 };
        this._prevCoords = { x: 0, y: 0 };
        this._startCoords = { x: 0, y: 0 };
        // initialize the class
        if (init) {
            this.init();
        }
    }
    _getDefaultProp() {
        return Object.assign(Object.assign({}, super._getDefaultProp()), { container: `#${this.prefix}`, usePassive: false, enabled: true });
    }
    get prefix() {
        return `${this._app.prefix}dragger`;
    }
    /**
     * Preloader container
     */
    get container() {
        return this._container;
    }
    /**
     * If is dragging at the moment
     */
    get isDragging() {
        return this._isDragging;
    }
    /**
     * Current coordinates relative to the Window
     */
    get coords() {
        return this._coords;
    }
    /**
     * Coordinates on drag start
     */
    get startCoords() {
        return this._startCoords;
    }
    /**
     * Set component events
     */
    _setEvents() {
        const { container } = this;
        const { usePassive } = this.prop;
        this.addEventListeners(container, 'mousedown', this._handleStart.bind(this), { passive: usePassive });
        this.addEventListeners(container, 'touchstart', this._handleStart.bind(this), { passive: usePassive });
    }
    /**
     * Add runtime events
     */
    _addRuntimeEvents() {
        const { usePassive } = this.prop;
        // end
        this._runtimeEvents.push(addEventListener(window, 'mouseup', this._handleEnd.bind(this), {
            passive: usePassive,
        }));
        this._runtimeEvents.push(addEventListener(window, 'touchend', this._handleEnd.bind(this), {
            passive: usePassive,
        }));
        // cancel
        this._runtimeEvents.push(addEventListener(window, 'touchcancel', this.cancel.bind(this), {
            passive: usePassive,
        }));
        this._runtimeEvents.push(addEventListener(window, 'blur', this.cancel.bind(this), {
            passive: usePassive,
        }));
    }
    /**
     * Remove runtime events
     */
    _removeRuntimeEvents() {
        this._runtimeEvents.forEach((event) => {
            event.remove();
        });
        this._runtimeEvents = [];
    }
    /**
     * Normalize event data.
     */
    _normalizeEvent(e) {
        if (e.type.includes('touch')) {
            const evt = e;
            const touch = evt.targetTouches[0] || evt.changedTouches[0];
            return {
                x: touch.clientX,
                y: touch.clientY,
                id: touch.identifier,
            };
        }
        const evt = e;
        return {
            x: evt.clientX,
            y: evt.clientY,
            id: null,
        };
    }
    /**
     * Event on start dragging
     */
    _handleStart(e) {
        if (!this.prop.enabled) {
            return false;
        }
        if (this.isDragging) {
            return false;
        }
        const evt = this._normalizeEvent(e);
        // prevent actions
        if (e.type === 'mousedown') {
            if (e.which === 1) {
                e.stopPropagation();
            }
            else {
                return false;
            }
        }
        // update states
        this._isDragging = true;
        this._pointerID = evt.id;
        // change coordinates
        this._coords = { x: evt.x, y: evt.y };
        this._prevCoords = { x: evt.x, y: evt.y };
        this._startCoords = { x: evt.x, y: evt.y };
        // add additional events
        this._addRuntimeEvents();
        // launch callbacks
        this.callbacks.tbt('start', {
            evt: e,
        });
        return true;
    }
    /**
     * Event on drag end
     */
    _handleEnd(e) {
        const evt = this._normalizeEvent(e);
        if (!this.isDragging || evt.id !== this._pointerID) {
            return false;
        }
        this.cancel();
        return true;
    }
    /**
     * Cancel dragging
     */
    cancel() {
        this._removeRuntimeEvents();
        this._isDragging = false;
        this.callbacks.tbt('end', false);
    }
    /**
     * Destroy the module
     */
    _destroy() {
        super._destroy();
        this._removeRuntimeEvents();
    }
}
